<template>
  <b-card class="summary-card text-center h-100">
    <div class="summary-count">{{ count }}</div>
    <h5 class="summary-title mb-2">{{ title }}</h5>
    <p v-if="subtitle" class="summary-subtitle text-muted mb-0">{{ subtitle }}</p>
  </b-card>
</template>

<script>
export default {
  name: "SummaryCard",

  props: {
    count: {
      type: [Number, String],
      default: 0,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.summary-card {
  .card-body {
    padding: 1rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .summary-count {
    font-size: 2.0rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 1rem;
  }

  .summary-title {
    font-size: 1.0rem;
    font-weight: 600;
  }

  .summary-subtitle {
    font-size: 0.9rem;
  }
}
</style>
